import { FlexBox, Icon, Text } from '@fable/components'
import { css, cx, useTheme } from '@fable/theme'
import { OverflowMenu, TextCounter, TextCounterProps } from '../shared'
import { useStats } from '../../lib/ctx/stats'
import { useState } from 'react'

export interface StatsHeaderTitleProps {
  top: string | React.ReactNode
  middle?: string | React.ReactNode
  bottom?: string | React.ReactNode
  animate?: boolean
  counter?: TextCounterProps
  colors?: {
    top?: string
    middle?: string
    bottom?: string
  }
  infoButton?: {
    text?: string | React.ReactNode
    hide?: boolean
    iconColor?: string
  }
}

export const StatsHeaderTitle = ({
  top,
  middle,
  bottom,
  animate = true,
  counter,
  colors,
  infoButton,
}: StatsHeaderTitleProps) => {
  const [open, setOpen] = useState(false)
  const { colors: themeColors } = useTheme()
  const theme = useStats((s) => s.theme)
  const topColor = colors?.top || themeColors.uiWhite
  const middleColor = colors?.middle || theme.primary
  const bottomColor = colors?.bottom || themeColors.uiWhite

  return (
    <div
      className={cx(
        css`
          font-size: 12px;
          width: 100%;
        `,
        'stats-header-title'
      )}
    >
      <Text type="label" sizing="L" color={topColor} weight="500">
        {top}
      </Text>
      <Text
        className={css`
          margin: 4px 0 0;
          transition: background-color ease-in-out 0.6s, color 0.6s;
          font-size: 32px;
          line-height: 28px;
          letter-spacing: -0.5%;
        `}
        type="header"
        tag="span"
        color={middleColor}
        weight="700"
      >
        {animate && counter ? <TextCounter {...counter} /> : middle}
      </Text>
      {bottom ? (
        <FlexBox
          className={css`
            width: 100%;
            gap: 4px;
          `}
          alignItems="center"
        >
          <Text
            className={css`
              width: ${infoButton?.hide ? '100%' : 'auto'};
            `}
            type="label"
            sizing="L"
            color={bottomColor}
            weight="500"
          >
            {bottom}
          </Text>
          {infoButton?.hide ? null : (
            <OverflowMenu
              wrapperStyles={css`
                top: 32px;
                left: 50%;
                transform: translateX(-50%) !important;
              `}
              open={open}
              setOpen={setOpen}
              icon="info"
              size="S"
              trigger={
                <Icon
                  type="info-solid"
                  className={css`
                    width: 14px;
                  `}
                  fill={infoButton?.iconColor || themeColors.uiWhite70}
                />
              }
              free
            >
              <FlexBox
                className={css`
                  padding: 0 12px;
                `}
                flexDirection="column"
              >
                <Icon
                  className={css`
                    margin-bottom: 4px;
                    width: 20px;
                  `}
                  type="info"
                  fill={themeColors.uiPewterGrey}
                />
                <Text type="body" sizing="M" color={themeColors.uiWhite}>
                  {infoButton?.text}
                </Text>
              </FlexBox>
            </OverflowMenu>
          )}
        </FlexBox>
      ) : null}
    </div>
  )
}
